import React from "react";
import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  DateField,
  FunctionField,
  TopToolbar,
} from "react-admin";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import { Box,useMediaQuery,useTheme,Button } from "@mui/material";
export const UserStatusHistoryList = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const navigate = useNavigate();
  const { id } = useParams();

  return (

    <>
    <Button
    startIcon={<ArrowBackIcon />}
    onClick={() => navigate(-1)}
    sx={{ color: "#fff", textTransform: "none",   mt: 4, width: "fit-content",backgroundColor: "#242424" ,px: 4, py: 1.25}}
    
  >
    Back
  </Button>
    <Box
      sx={{
        mt: 2,
        backgroundColor: "#242424",
        borderRadius: 2,
        boxShadow: "none !important",
        padding: isSmallScreen ? { xs: 0, sm: 0 } : { xs: 1.5, sm: 2 },
      }}
    >
       
      <List
        title="User Status History"
        resource="User Status History"
        filter={{ "targetUser.objectId": id }}
        sort={{ field: "timestamp", order: "DESC" }}
        perPage={10}
        actions={null}
      >
        <Datagrid bulkActionButtons={false} rowClick={false}>
          <FunctionField
            label="Changed By"
            render={(record) => record?.actor?.username || "—"}
          />
          <FunctionField
            label="Updated Status"
            render={(record) => (record?.newStatus ? "Active" : "In-active")}
          />
          <DateField source="timestamp" label="Changed At" showTime />
        </Datagrid>
      </List>
    </Box>
    </>
  );
};
